import { useAuthContext } from './useAuthContext';
import Cookies from 'js-cookie';

export const useLogout = () => {
  const { dispatch } = useAuthContext();

  const logout = async () => {
    const currentUser = JSON.parse(localStorage.getItem('user'));

    if (currentUser && currentUser.accessToken) {
      try {
        const config = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${currentUser.accessToken}`,
          },
          body: JSON.stringify({ token: currentUser.refreshToken }),
        };

        const response = await fetch(process.env.REACT_APP_BACKEND_URI + 'user/logout', config);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

      } catch (error) {
        console.error("Logout error:", error);
      }
    }

    dispatch({ type: 'LOGOUT' });
    localStorage.removeItem('user');
    localStorage.removeItem('refreshToken'); // Clear refresh token

    if (Cookies.get('accessToken') !== undefined) {
      Cookies.remove('accessToken');
    }
    if (Cookies.get('adminKey') !== undefined) {
      Cookies.remove('adminKey');
    }
  };

  return { logout };
};